export type UpdateBusinessIosEnvelope = {
  title?: string;
  message?: string;
  business_id?: number;
};

export function isUpdateBusinessIosFailureEnvelope(
  data: UpdateBusinessIosEnvelope,
  responseOk: boolean
): boolean {
  if (!responseOk || data.business_id === 0) return true;

  const title = data.title?.trim() || '';
  const message = data.message?.trim() || '';
  return /^(alert|alarm)$/i.test(title)
    && /wrong social link|falscher sozialer link/i.test(message);
}
